export class BaseDTO {
    id?: number;
    guidRegistro?:string;
}